// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {

    $(document).ready(function () {

        //$.components.registerComponent(".window-specs-block", function ($root) {
            var $root = document.querySelectorAll('.window-specs-block');
            $root = $($root);  

            var specification = {
                dom: {
                    base: $root,
                    surfaces: $root.find(".window-specs-surface"),
                    surface_first: $root.find(".window-specs-surface:first-child"),
                    numbers: $root.find(".spec-number"),
                    images: $root.find(".specs-image"),
                    info: $root.find(".window-specs"),
                    info_tabs: $root.find(".window-specs .tab-title"),
                    filtered: $root.find("[data-surface]")
                },
                set: {
                    activeClass: "active", 
                    selected: null
                },
                fn: {
                    selectSurface: function (n) {
                        $set.selected = n.data("surface");
                        $dom.filtered.removeClass("active");
                        n.addClass("active");
                        $dom.images.filter('[data-surface="' + $set.selected + '"]').addClass("active");
                        $dom.info.filter('[data-surface="' + $set.selected + '"]').addClass("active");
                        $fn.resetNumbers();
                    },
                    placeNumbers: function () {
                        $dom.numbers.each(function () {
                            var positions = $(this).data("position"),
                                positionArray = positions.split(",");
                            $(this).css({
                                left: positionArray[0] + "px",
                                top: positionArray[1] + "px"
                            });
                        });
                    },
                    triggerTabClick: function (number) {
                        $dom.info.find(".tab-number").filter(
                            function () {
                                return $(this).text() == number;
                            }).trigger("click");
                    },
                    handleNumbers: function (el,r) {
                        $dom.numbers.removeClass("active");
                        if (r == false) {
                            el.addClass("active")
                        }
                    },
                    resetNumbers: function () {
                        $dom.info.not(".active").find(".accordion-tab").removeClass("opened").find(".tab-content").removeAttr("style");
                        $dom.images.not(".active").find(".spec-number").removeClass("active");
                    }
                }
            },
            $dom = specification.dom,
            $set = specification.set,
            $fn = specification.fn;

            $fn.placeNumbers();
            $dom.surfaces.on({
                click: function () {
                    $fn.selectSurface($(this));
                }
            });
            $fn.selectSurface($dom.surface_first);
            $dom.numbers.on({
                click: function (n) {
                    n.preventDefault();
                    $fn.triggerTabClick($(this).text());
                }
            });
            $dom.info_tabs.on({
                click: function () {
                    var parent = $(this).parent(),
                        tab = $dom.numbers.filter(function () { return $(this).text() == parent.find(".tab-number").text(); }),
                        isOpen = $(this).parent().hasClass("opened");
                    $fn.handleNumbers($(tab), isOpen); 
                }
            });
        //});
    });
}
(window, document, jQuery));